import { Controller } from "@hotwired/stimulus"

// Auto-submits a form after a debounce delay (300ms).
// Replicates the DHH/37signals live search pattern (HEY.com cmd+k).
//
// Usage:
//   <form data-controller="manage--search-debounce">
//     <input type="text" data-action="input->manage--search-debounce#search">
//   </form>
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this._timeout = null
  }

  disconnect() {
    clearTimeout(this._timeout)
  }

  search() {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }
}
